import { ExtractActions } from '@vfde-sails/core';
import {
    ACTION_ADD_COMPONENTS,
    ACTION_ELIGIBILITY_CHECK,
    ACTION_INIT_PAGE,
    ACTION_INIT_PAGE_SUCCESS,
    ACTION_LOGIN,
    ACTION_SEND_TAN,
    ACTION_SEND_TAN_SUCCESS,
    ACTION_SET_ERROR,
    ACTION_SET_IS_LOGGED_IN,
    ACTION_SET_MTAN_STEP,
} from './constant';
import {
    BtxType,
    IComponents,
    IErrorObj,
    StepNumber,
} from './interfaces/main.interface';

/**
 * Init page
 */
const initPage = (btx: BtxType, formActions: IFormActions) => ({
    type: ACTION_INIT_PAGE,
    btx,
    formActions,
});
/**
 * Toggle login
 */
const initPageSuccess = () => ({
    type: ACTION_INIT_PAGE_SUCCESS,
});
/**
 * Set the user's status (is logged in)
 */
const setIsLoggedIn = (isUserLoggedIn: boolean) => ({
    type: ACTION_SET_IS_LOGGED_IN,
    isUserLoggedIn,
});
/**
 * Take the phone number input and send it to the service
 */
const sendTan = (phoneNumber: string) => ({
    type: ACTION_SEND_TAN,
    phoneNumber,
});
/**
 * sendTanSuccess
 */
const sendTanSuccess = () => ({
    type: ACTION_SEND_TAN_SUCCESS,
});
/**
 * Take the SMS code input and send it to the service
 */
const login = (phoneNumber: string, tan: string) => ({
    type: ACTION_LOGIN,
    phoneNumber,
    tan,
});
/**
 * Do an eligibility check for vvl, tariffChange or redplus
 */
const eligibilityCheck = (btx: BtxType, mtanStep: StepNumber) => ({
    type: ACTION_ELIGIBILITY_CHECK,
    btx,
    mtanStep,
});
/**
 * Set the mtan step to either 0 or 1 which will modify the UI (step 0 - phone number input, step 1 - sms code input)
 */
const setMtanStep = (mtanStep: StepNumber) => ({
    type: ACTION_SET_MTAN_STEP,
    mtanStep,
});
/**
 * addComponent
 */
const addComponents = (components: IComponents) => ({
    type: ACTION_ADD_COMPONENTS,
    components,
});
/**
 * setError
 */
const setError = (error: IErrorObj | null) => ({
    type: ACTION_SET_ERROR,
    error,
});

/**
 * Action Creators Object
 */
export const actionCreators = {
    initPage,
    initPageSuccess,
    setIsLoggedIn,
    sendTan,
    sendTanSuccess,
    login,
    eligibilityCheck,
    setMtanStep,
    addComponents,
    setError,
};

/**
 * Action Dispatchers Object
 */
export const actionDispatchers = {
    initPage,
    eligibilityCheck,
    setMtanStep,
    login,
    setError,
    sendTan,
};

/**
 * Action Creators
 */
export type AppActionCreators = typeof actionCreators;

/**
 * Action Dispatchers
 */
export type AppActionDispatchers = typeof actionDispatchers;

/**
 * Extracted type for actions
 */
export type AppAction = ExtractActions<AppActionCreators>;

/**
 * initPage payload interface
 */
export interface IFormActions {
    /**
     * setMtanStep action
     */
    setMtanStep: AppActionDispatchers['setMtanStep'];
    /**
     * sendTan action
     */
    sendTan: AppActionDispatchers['sendTan'];
    /**
     * login action
     */
    login: AppActionDispatchers['login'];
}
